export default 'Select a date';